import script from "./AutoCompleteClientes.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoCompleteClientes.vue?vue&type=script&setup=true&lang=ts"

import "./AutoCompleteClientes.vue?vue&type=style&index=0&id=6d6428fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d6428fb"]])

export default __exports__